"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _luxon = require("luxon");

var _reactVis = require("react-vis");

var _chartUtils = require("../../chartUtils");

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

var _noDataInsert = _interopRequireDefault(require("../noDataInsert"));

var _styles = require("../../styles");

var _propTypes2 = require("../../constants/propTypes");

var _colors = require("../../constants/colors");

require("react-vis/dist/style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Display = /*#__PURE__*/function (_PureComponent) {
  _inherits(Display, _PureComponent);

  var _super = _createSuper(Display);

  function Display() {
    var _this;

    _classCallCheck(this, Display);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.getXAxisTickInfo = (0, _memoizeOne["default"])(function (viewStartDateTime, viewEndDateTime, timeZone) {
      return (0, _chartUtils.getTickInfoByInterval)({
        endDate: viewEndDateTime,
        startDate: viewStartDateTime,
        timeZone: timeZone
      });
    });
    return _this;
  }

  _createClass(Display, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          displayCoordinates = _this$props.displayCoordinates,
          endMillis = _this$props.endMillis,
          hasBattery = _this$props.hasBattery,
          isLoading = _this$props.isLoading,
          startMillis = _this$props.startMillis,
          timeZone = _this$props.timeZone,
          viewEndDateTime = _this$props.viewEndDateTime,
          viewStartDateTime = _this$props.viewStartDateTime;
      var batteryChargeCoordinates = displayCoordinates.batteryChargeCoordinates,
          batteryDischargeCoordinates = displayCoordinates.batteryDischargeCoordinates,
          billedKwhCoordinates = displayCoordinates.billedKwhCoordinates,
          consumptionCoordinates = displayCoordinates.consumptionCoordinates,
          contractCoordinates = displayCoordinates.contractCoordinates,
          estimatedProductionCoordinates = displayCoordinates.estimatedProductionCoordinates,
          exportCoordinates = displayCoordinates.exportCoordinates,
          importCoordinates = displayCoordinates.importCoordinates,
          peerCoordinates = displayCoordinates.peerCoordinates,
          peerV2Coordinates = displayCoordinates.peerV2Coordinates,
          selfConsumptionCoordinates = displayCoordinates.selfConsumptionCoordinates,
          solarCoordinates = displayCoordinates.solarCoordinates,
          systemProductionCoordinates = displayCoordinates.systemProductionCoordinates,
          weatherCorrectedCoordinates = displayCoordinates.weatherCorrectedCoordinates;
      var tickInfo = this.getXAxisTickInfo(viewStartDateTime, viewEndDateTime, timeZone);
      return /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
        dataTestid: "all-chart",
        animation: "noAnimation",
        height: 300,
        margin: {
          left: 70,
          right: 0
        },
        xDomain: [startMillis, endMillis],
        xType: "time"
      }, /*#__PURE__*/_react["default"].createElement(_reactVis.GradientDefs, null, /*#__PURE__*/_react["default"].createElement("pattern", {
        id: "export-crosshatch",
        width: "4",
        height: "4",
        patternUnits: "userSpaceOnUse"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        className: "vx-pattern-line",
        d: "M 0,4 l 4,-4 M -1,1 l 2,-2 M 3,5 l 2,-2",
        stroke: _colors.DARK_GREY,
        strokeWidth: "1",
        strokeLinecap: "square",
        shapeRendering: "auto"
      }))), /*#__PURE__*/_react["default"].createElement(_reactVis.HorizontalGridLines, {
        style: _styles.dashedGridStyle
      }), _noDataInsert["default"].apply(void 0, [startMillis, endMillis, isLoading].concat(_toConsumableArray(Object.values(displayCoordinates)))), /*#__PURE__*/_react["default"].createElement(_reactVis.AreaSeries, {
        curve: "curveLinear",
        data: solarCoordinates,
        style: _styles.solarAreaStyle
      }), hasBattery && [/*#__PURE__*/_react["default"].createElement(_reactVis.AreaSeries, {
        data: batteryChargeCoordinates,
        key: "chargeSeries",
        style: _styles.batteryChargeStyle
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.AreaSeries, {
        data: batteryDischargeCoordinates,
        key: "dischargeSeries",
        style: _styles.batteryDischargeStyle
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
        data: systemProductionCoordinates,
        key: "systemProductionSeries",
        style: _styles.systemProductionLineStyle
      })], /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
        curve: "curveLinear",
        data: contractCoordinates,
        style: _styles.contractGenerationsLineStyle
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
        curve: "curveLinear",
        data: peerV2Coordinates,
        delta: 1,
        key: "peerV2Series",
        style: _styles.peerV2LineStyle,
        unit: "day"
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
        curve: "curveLinear",
        data: peerCoordinates,
        style: _styles.peerAdjGenerationsLineStyle
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
        curve: "curveLinear",
        data: billedKwhCoordinates,
        style: _styles.billedKwhLineStyle
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
        curve: "curveLinear",
        data: estimatedProductionCoordinates,
        style: _styles.estimatedProductionLineStyle
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
        curve: "curveLinear",
        data: weatherCorrectedCoordinates,
        style: _styles.weatherCorrectedLineStyle
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
        data: consumptionCoordinates,
        key: "consumptionSeries",
        style: _styles.consumptionLineStyle
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.AreaSeries, {
        data: selfConsumptionCoordinates,
        key: "selfConsumptionSeries",
        style: _styles.selfConsumptionAreaStyle
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.AreaSeries, {
        data: exportCoordinates,
        key: "exportSeries",
        style: _styles.exportCrosshatchStyle
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.AreaSeries, {
        data: importCoordinates,
        key: "importSeries",
        style: _styles.importCrosshatchStyle
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.XAxis, {
        key: "allXAxis",
        style: _objectSpread(_objectSpread({}, _styles.axisStyle), {}, {
          text: {
            textAnchor: 'start',
            fontSize: 12,
            fill: _colors.NAVY
          }
        }),
        tickValues: tickInfo.values,
        tickFormat: tickInfo.formats
      }));
    }
  }]);

  return Display;
}(_react.PureComponent);

Display.propTypes = {
  displayCoordinates: _propTypes["default"].shape({
    batteryChargeCoordinates: _propTypes2.coordinatePropTypes,
    batteryDischargeCoordinates: _propTypes2.coordinatePropTypes,
    consumptionCoordinates: _propTypes2.coordinatePropTypes,
    contractCoordinates: _propTypes2.coordinatePropTypes,
    exportCoordinates: _propTypes2.coordinatePropTypes,
    importCoordinates: _propTypes2.coordinatePropTypes,
    peerCoordinates: _propTypes2.coordinatePropTypes,
    peerV2Coordinates: _propTypes2.coordinatePropTypes,
    selfConsumptionCoordinates: _propTypes2.coordinatePropTypes,
    solarCoordinates: _propTypes2.coordinatePropTypes,
    systemProductionCoordinates: _propTypes2.coordinatePropTypes
  }),
  endMillis: _propTypes["default"].number.isRequired,
  hasBattery: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  startMillis: _propTypes["default"].number.isRequired,
  timeZone: _propTypes["default"].string.isRequired,
  viewEndDateTime: _propTypes["default"].instanceOf(_luxon.DateTime).isRequired,
  viewStartDateTime: _propTypes["default"].instanceOf(_luxon.DateTime).isRequired
};
Display.defaultProps = {
  displayCoordinates: {},
  hasBattery: false,
  isLoading: false
};
var _default = Display;
exports["default"] = _default;